import React from "react";
import { Modal, Button } from "semantic-ui-react";
import useInspectionDeleteMutation from "../../../../hooks/inspections/useInspectionDeleteMutation";

export interface InspectionDeleteModalProps {
  id: number | string;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}
export default function InspectionDeleteModal({ id, open, onClose, onSuccess }: InspectionDeleteModalProps) {
  const { deleteInspection, isLoading } = useInspectionDeleteMutation({ id, onSuccess });

  return (
    <Modal size='tiny' open={open} onClose={onClose}>
      <Modal.Header>Delete Inspection</Modal.Header>
      <Modal.Content>
        Are you sure you want to delete this inspection? All data for this inspection will be lost.
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={onClose}>
          Cancel
        </Button>
        <Button color='red' loading={isLoading} onClick={deleteInspection}>
          Delete
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
